__webpack_require__.p = "/templates/restaurant/";